import styles from './cardThemes.scss';
import { getIsDarkTheme } from 'owa-fabric-theme';

const classNames = {
    Yellow: [styles.lightColors, styles.baseCard, styles.yellowCard],
    Green: [styles.lightColors, styles.baseCard, styles.greenCard],
    Pink: [styles.lightColors, styles.baseCard, styles.pinkCard],
    Purple: [styles.lightColors, styles.baseCard, styles.purpleCard],
    Blue: [styles.lightColors, styles.baseCard, styles.blueCard],
    Gray: [styles.lightColors, styles.baseCard, styles.grayCard],
    Charcoal: [styles.darkColors, styles.baseCard, styles.charcoalCard],
};

export default function getCardThemeClassNames(colorName: string | null | undefined) {
    return (
        classNames[colorName || ''] || (getIsDarkTheme() ? classNames.Charcoal : classNames.Gray)
    );
}
